type OrganizationAwareUser = {
  organization_id?: number | null;
  organization_name?: string | null;
  active_organization_id?: number | null;
  organizations?: Array<unknown> | null;
};

export function userHasOrganization(user: OrganizationAwareUser | null | undefined): boolean {
  const organizations: unknown[] = Array.isArray(user?.organizations)
    ? (user?.organizations ?? [])
    : [];

  return Boolean(
    user?.organization_id ||
    user?.organization_name ||
    user?.active_organization_id ||
    organizations.length > 0,
  );
}
